import { render } from "./BookingLegalTerms.vue?vue&type=template&id=251891d4"
import script from "./BookingLegalTerms.vue?vue&type=script&lang=js"
export * from "./BookingLegalTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingLegalTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "251891d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('251891d4', __exports__)) {
    api.reload('251891d4', __exports__)
  }
  
  module.hot.accept("./BookingLegalTerms.vue?vue&type=template&id=251891d4", () => {
    api.rerender('251891d4', render)
  })

}


export default __exports__